import { useTranslation } from 'react-i18next'

import { CITIES } from '../../data/cities.ts'
import type { Rally } from '../../data/rallies.ts'

interface CityProps {
  city: string
  rally?: Rally
}
function City({ city, rally }: CityProps) {
  const { t } = useTranslation()

  const ns = rally?.citiesI18n ?? 'cities'
  const link = (rally?.cities ?? CITIES)[city]?.link || null
  const day = t(`${ns}.${city}.day`)
  const location = t(`${ns}.${city}.location`)
  const cleanTime = t(`${ns}.${city}.cleanTime`)
  const monthShortKey = rally?.days.find((d) => d.cities.includes(city))?.monthShortKey ?? 'home.dec'
  // no time for this city (e.g. not announced): just the date, without a trailing comma
  const dayAndTime = `${t(`home.${day}`)} ${t(monthShortKey)}${cleanTime ? `, ${cleanTime}` : ''}`
  const locationText = location ? location : 'TBC'

  return (
    <li key={city} className='list-none py-2'>
      <div className='grid grid-cols-[1fr_2fr] gap-x-4 items-start'>
        <div className='font-bold justify-start text-left'>
          {link ? (
            <a
              href={link}
              target='_blank'
              rel='noopener noreferrer'
              className='text-left hover:underline cursor-pointer'
            >
              <span className='text-xl'>{t(`${ns}.${city}.city`)} </span>
              <span>🔗</span>
            </a>
          ) : (
            <span className='text-xl text-left'>{t(`${ns}.${city}.city`)}</span>
          )}
        </div>

        <div className='text-right'>
          <div className='text-sm font-semibold text-blue-900'>{dayAndTime}</div>
          <div className='text-sm text-blue-900'>{locationText}</div>
        </div>
      </div>
    </li>
  )
}

export default City
